<template>
    <div>
        <v-card class="ma-2" v-if="relatedProducts">
            <related-products :productIds="relatedProducts"></related-products>
        </v-card>

        <v-sheet class="pa-3">
            <basket-items floating coupon displayFreeShippingInfo></basket-items>
        </v-sheet>

        <v-sheet class="px-3 pb-3 text-xs-right">
            <v-btn :to="{name: 'basket'}" @click.native="$emit('input', false)">
                {{ 'To the basket of goods' | translation }}
            </v-btn>
            <v-btn
                class="mr-0"
                color="primary"
                :to="checkoutStepData"
                @click.native="$emit('input', false)"
            >
                {{ 'Proceed to checkout' | translation }}
            </v-btn>
        </v-sheet>
    </div>
</template>

<script>
    import RelatedProducts from '@breakmedia/prime-vue-product/src/RelatedProducts';
    import {mapState} from 'vuex';
    import Basket from '../Basket';

    export default {
        components: {
            RelatedProducts,
        },
        data(){
            return {
                maxCrosssellsProductsDisplay: 2,
            };
        },
        computed: {
            ...mapState(Basket.name, {
                products: state => state.products,
            }),
            ...mapState('Customer', ['customerHasDSGVO']),
            checkoutStepData() {
                return {
                    name: 'checkout',
                    params: {
                        stepName: this.customerHasDSGVO ? 'summary' : 'address',
                    }
                };
            },
            relatedProducts(){
                let result = [];

                label:
                    for (let basketItem of Object.values(this.$basket.getBasketItems())) {
                        let product = this.products ? this.products[basketItem.product_id] : {};
                        if(product && product.crosssells && product.crosssells.length) {
                            for (let crosssell of product.crosssells) {
                                if(result.length < this.maxCrosssellsProductsDisplay) {
                                    result.push(crosssell);
                                } else {
                                    break label;
                                }
                            }
                        }
                    }

                return result;
            },
        },
    };
</script>